import get from 'lodash/get';
import reduce from 'lodash/reduce';

import entity from './entity';
import config from '../../../../config';
import fetch from '../../../../utils/fetch';
import logger from '../../../../utils/logger';

const TYPES = {
  ...entity.getTypes(),
  GET_ALL_COMPACT_REQUEST: `${entity.name}/GET_ALL_COMPACT_REQUEST`,
  GET_ALL_COMPACT_REQUEST_SUCCESS: `${entity.name}/GET_ALL_COMPACT_REQUEST_SUCCESS`,
  GET_ALL_COMPACT_REQUEST_ERROR: `${entity.name}/GET_ALL_COMPACT_REQUEST_ERROR`,
  GET_ALL_COMPACT_BY_EMAIL_REQUEST: `${entity.name}/GET_ALL_COMPACT_BY_EMAIL_REQUEST`,
  GET_ALL_COMPACT_BY_EMAIL_REQUEST_SUCCESS: `${entity.name}/GET_ALL_COMPACT_BY_EMAIL_REQUEST_SUCCESS`,
  GET_ALL_COMPACT_BY_EMAIL_REQUEST_ERROR: `${entity.name}/GET_ALL_COMPACT_BY_EMAIL_REQUEST_ERROR`,
  UPDATE_PROFILE_REQUEST: `${entity.name}/UPDATE_PROFILE_REQUEST`,
  UPDATE_PROFILE_REQUEST_SUCCESS: `${entity.name}/UPDATE_PROFILE_REQUEST_SUCCESS`,
  UPDATE_PROFILE_REQUEST_ERROR: `${entity.name}/UPDATE_PROFILE_REQUEST_ERROR`,
  GET_LOCATION_REQUEST: `${entity.name}/GET_LOCATION_REQUEST`,
  GET_LOCATION_REQUEST_SUCCESS: `${entity.name}/GET_LOCATION_REQUEST_SUCCESS`,
  GET_LOCATION_REQUEST_ERROR: `${entity.name}/GET_LOCATION_REQUEST_ERROR`,
  GET_PROFILE_JOBS_BY_COMPANY_NAME_REQUEST: `${entity.name}/GET_PROFILE_JOBS_BY_COMPANY_NAME_REQUEST`,
  GET_PROFILE_JOBS_BY_COMPANY_NAME_SUCCESS: `${entity.name}/GET_PROFILE_JOBS_BY_COMPANY_NAME_SUCCESS`,
  GET_PROFILE_JOBS_BY_COMPANY_NAME_ERROR: `${entity.name}/GET_PROFILE_JOBS_BY_COMPANY_NAME_ERROR`,
  ADD_PROFILES: `${entity.name}/ADD_PROFILES`,
};

export {
  TYPES,
};

const entityActions = entity.getActions();

const update = (data, options = {}) => async (dispatch, getState) => {
  try {
    const state = getState();
    let id = get(state, 'authentication.profileKey');

    if (!id) {
      const { claimed, profileKey } = await fetch(`${config.apiUrl}/v1/profiles/status`);
      if (!claimed) id = profileKey;
    }

    if (!id) throw new Error('Unable to find profile key');

    const response = await dispatch(entityActions.update(id, data, options));
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllCompact = data => async (dispatch) => {
  dispatch({ type: TYPES.GET_ALL_COMPACT_REQUEST });
  try {
    const response = await entity.api.getEntitiesCompact(data);
    const responseData = reduce(get(response, 'data', []), (result, entity) => ({ ...result, [entity.key]: entity }), {});
    dispatch({ type: TYPES.GET_ALL_COMPACT_REQUEST_SUCCESS, payload: responseData });

    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_ALL_COMPACT_REQUEST_ERROR, payload: error });
    throw error;
  }
};

const getAllByEmail = (bodyData, options = {}) => async (dispatch) => {
  dispatch({ type: TYPES.GET_ALL_COMPACT_BY_EMAIL_REQUEST });

  try {
    const response = await entity.api.getEntitiesByEmail(bodyData, options);
    const data = reduce(response.data, (result, entity) => ({ ...result, [entity.key]: entity }), {});
    dispatch({ type: TYPES.GET_ALL_COMPACT_BY_EMAIL_REQUEST_SUCCESS, payload: data });

    return response.data;
  } catch (error) {
    dispatch({ type: TYPES.GET_ALL_COMPACT_BY_EMAIL_REQUEST_ERROR, payload: error });

    throw error;
  }
};

const updateProfile = options => async (dispatch) => {
  dispatch({ type: TYPES.UPDATE_PROFILE_REQUEST });

  try {
    const query = get(options, 'data', {});
    const params = get(options, 'params', {});
    const response = await entity.api.updateEntities(query, params);
    const data = reduce(response, (result, entity) => ({ ...result, [entity.key]: entity }), {});
    dispatch({ type: TYPES.UPDATE_PROFILE_REQUEST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: TYPES.UPDATE_PROFILE_REQUEST_ERROR, payload: error });
  }
};

const getByUserName = options => async (dispatch) => {
  dispatch({ type: TYPES.GET_REQUEST });

  const username = get(options, 'username', null);

  try {
    const response = await entity.api.getEntitiesByUsername(username, options.fetch);
    const profile = get(response, 'data');
    const profileKey = entity.getId(profile);

    dispatch({ type: TYPES.GET_REQUEST_SUCCESS, payload: { [profileKey]: profile } });

    return profileKey;
  } catch (error) {
    dispatch({ type: TYPES.GET_REQUEST_ERROR, payload: error });

    throw error;
  }
};


const getLocationByArrival = options => async (dispatch) => {
  dispatch({ type: TYPES.GET_LOCATION_REQUEST });

  try {
    const response = await entity.api.getFreeFormLocationByArrival(options);
    const location = get(response, 'data');

    dispatch({ type: TYPES.GET_LOCATION_REQUEST_SUCCESS, payload: { arrivalLocation: location } });

    return location;
  } catch (error) {
    dispatch({ type: TYPES.GET_LOCATION_REQUEST_ERROR, payload: error });
    logger.logError('Unable to fetch location', error);
    return null;
  }
};

const getProfileJobsByCompanyName = options => async (dispatch) => {
  dispatch({ type: TYPES.GET_PROFILE_JOBS_BY_COMPANY_NAME_REQUEST });

  try {
    const query = get(options, 'query', {});
    const response = await entity.api.getProfileJobsByCompanyName(query);
    const profiles = JSON.parse(response.data);
    if (profiles) {
      const data = reduce(profiles, (result, value, key) => (
        { ...result, [key]: { company_relevant_jobs: value } }
      ), {});
      dispatch({ type: TYPES.GET_PROFILE_JOBS_BY_COMPANY_NAME_SUCCESS, payload: data });
    }

    return profiles;
  } catch (error) {
    dispatch({ type: TYPES.GET_PROFILE_JOBS_BY_COMPANY_NAME_ERROR, payload: error });
    logger.logError('Unable to fetch profile jobs for a company name', error);
    return null;
  }
};

const saveContactsToProfile = options => async () => {
  try {
    const data = get(options, 'data', {});
    await entity.api.saveContacts(data, { fullResponse: true });
  } catch (error) {
    throw error;
  }
};

const addProfiles = profiles => ({
  type: TYPES.ADD_PROFILES,
  payload: profiles,
});

export default {
  TYPES,
  getAllCompact,
  updateProfile,
  getByUserName,
  getLocationByArrival,
  getAllByEmail,
  ...entity.getActions(),
  update,
  addProfiles,
  getProfileJobsByCompanyName,
  saveContactsToProfile,
};
